var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.checkBtn
        ? _c(
            "div",
            [
              _c("el-card", { staticClass: "employees-card-bottom" }, [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "plan-tabs-content mb20" },
                      [
                        _c(
                          "el-tabs",
                          {
                            on: { "tab-click": _vm.tapClick },
                            model: {
                              value: _vm.tabCur,
                              callback: function ($$v) {
                                _vm.tabCur = $$v
                              },
                              expression: "tabCur",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: { label: "待处理", name: "6" },
                            }),
                            _vm._v(" "),
                            _c("el-tab-pane", {
                              attrs: { label: "考核记录", name: "7" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("merits", {
                      ref: "merits",
                      attrs: { handle: _vm.handle },
                      on: { meritsHandleCheck: _vm.meritsHandleCheck },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.checkBtn
        ? _c("audit-process", {
            ref: "auditProcess",
            attrs: {
              id: _vm.id,
              "add-button": _vm.addBtn,
              "is-tips": _vm.isTips,
              "process-index": _vm.status,
              strType: _vm.strType,
            },
            on: { auditProcess: _vm.auditProcess, saveOk: _vm.saveOk },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }